export default (event, type, config) => {
  event.preventDefault();

  if (type === "trackPageView") {
    window.dataLayer.push({
      event: "trackPageView",
      url: config.url,
      locale: config.locale || "zh-cn",
      userId: config.userId || "",
      token: config.token || "",
      isVip: config.isVip || null,
      visitTimes: "",
      visitDuration: "",
      usingDuration: "",
      appVersion: "1.0.0",
      adblock: null,
      specialContent: null,
      product: "h5-app",
      host: document.location.host,
      apiKey: "fotor"
    });
  }

  if (type === "trackEvent") {
    window.dataLayer.push({
      event: "trackEvent",
      category: config.category,
      action: config.action,
      label: config.label,
      locale: config.locale || "zh-cn",
      userId: config.userId || "",
      token: config.token || "",
      isVip: config.isVip || null,
      visitTimes: "",
      visitDuration: "",
      usingDuration: "",
      appVersion: "1.0.0",
      adblock: null,
      specialContent: null,
      product: "h5-app",
      host: document.location.host,
      apiKey: "fotor"
    });
  }

  window.open(config.path, config.openInNewTab ? "_blank" : "_self");
};
